import { useMutation } from '@tanstack/react-query';

import emailService from './emailService';

import type {
    CycleEvaluationGroupSendTestEmailRequest,
    CycleEvaluationSendTestEmailRequest,
    CycleInstanceSendTestEmailRequest,
} from './types';

import { EmailMutationKey } from '@/constants/QueryKeys';

const useSendCycleInstanceTestEmail = () => {
    return useMutation({
        mutationKey: [EmailMutationKey.SEND_TEST_EMAIL],
        mutationFn: (request: CycleInstanceSendTestEmailRequest) =>
            emailService.sendCycleInstanceTestEmail(request),
    });
};

const useSendCycleEvaluationTestEmail = () => {
    return useMutation({
        mutationKey: [EmailMutationKey.SEND_TEST_EMAIL],
        mutationFn: (request: CycleEvaluationSendTestEmailRequest) =>
            emailService.sendCycleEvaluationTestEmail(request),
    });
};

const useSendCycleEvaluationGroupTestEmail = () => {
    return useMutation({
        mutationKey: [EmailMutationKey.SEND_TEST_EMAIL],
        mutationFn: (request: CycleEvaluationGroupSendTestEmailRequest) =>
            emailService.sendCycleEvaluationGroupTestEmail(request),
    });
};

export {
    useSendCycleInstanceTestEmail,
    useSendCycleEvaluationTestEmail,
    useSendCycleEvaluationGroupTestEmail,
};
